// import React from "react";
// import "./Services.css";
// import {
//   FaPlaneDeparture,
//   FaTaxi,
//   FaRoute,
//   FaMapMarkerAlt,
//   FaCarSide,
//   FaBriefcase,
//   FaArrowRight,
//   FaTags,
//   FaRoad,
// } from "react-icons/fa";



// const services = [
//   {
//     id: "01",
//     title: "Cab Service in Thane",
//     image: "/images/services/Cab-Service-in-Thane.jpg",
//     icon: <FaTaxi />,
//     description:
//       "Professional taxi services in Thane for local, airport, and outstation travel with experienced drivers.",
//     feature1: "24×7 Service",
//     feature2: "Safe Travel",
//     link: "/Cab-Service-in-Thane",
//   },

//   {
//     id: "02",
//     title: "Cab Services in Mumbai",
//     image: "/images/services/Cab-Services-in-Mumbai.jpg",
//     icon: <FaCarSide />,
//     description:
//       "Affordable cab services in Mumbai for local rides, airport transfers, and outstation trips.",
//     feature1: "Affordable Fare",
//     feature2: "Professional Drivers",
//     link: "/Cab-Services-in-Mumbai",
//   },

//   {
//     id: "03",
//     title: "Cheapest Cab Service in Mumbai",
//     image: "/images/services/Cheapest-Cab-Service-in-Mumbai.jpg",
//     icon: <FaTags />,
//     description:
//       "Book the cheapest cab service in Mumbai with clean cars and reliable drivers for every journey.",
//     feature1: "Lowest Fare",
//     feature2: "24×7 Booking",
//     link: "/Cheapest-Cab-Service-in-Mumbai",
//   },

//   {
//     id: "04",
//     title: "Mumbai Airport Cab Service",
//     image: "/images/services/Mumbai-Airport-Cab-Service.jpg",
//     icon: <FaPlaneDeparture />,
//     description:
//       "Reliable Mumbai Airport pickup and drop taxi service with timely airport transfers.",
//     feature1: "Airport Pickup",
//     feature2: "Flight Tracking",
//     link: "/Mumbai-Airport-Cab-Service",
//   },

//   {
//     id: "05",
//     title: "Mumbai Airport to Pune Cab",
//     image: "/images/services/Mumbai-Airport-to-Pune-Cab.jpg",
//     icon: <FaRoute />,
//     description:
//       "Comfortable Mumbai Airport to Pune cab service for one-way and round-trip travel.",
//     feature1: "One Way",
//     feature2: "Round Trip",
//     link: "/Mumbai-Airport-to-Pune-Cab",
//   },

//   {
//     id: "06",
//     title: "Mumbai Airport to Surat Cab",
//     image: "/images/services/Mumbai-Airport-to-Surat-Cab.jpg",
//     icon: <FaRoad />,
//     description:
//       "Book airport taxi from Mumbai Airport to Surat with experienced outstation drivers.",
//     feature1: "Outstation",
//     feature2: "Comfort Ride",
//     link: "/Mumbai-Airport-to-Surat-Cab",
//   },

//   {
//     id: "07",
//     title: "Mumbai Outstation Cabs",
//     image: "/images/services/Mumbai-Outstation-Cabs.jpg",
//     icon: <FaRoute />,
//     description:
//       "Comfortable outstation taxi service from Mumbai to destinations across Maharashtra and India.",
//     feature1: "24×7 Service",
//     feature2: "Professional Driver",
//     link: "/Mumbai-Outstation-Cabs",
//   },

//   {
//     id: "08",
//     title: "Mumbai to Nashik Cab Service",
//     image: "/images/services/Mumbai-to-Nashik-cab-service.jpg",
//     icon: <FaMapMarkerAlt />,
//     description:
//       "Safe and affordable Mumbai to Nashik cab service for business, family, and pilgrimage trips.",
//     feature1: "Door Pickup",
//     feature2: "Safe Journey",
//     link: "/Mumbai-to-Nashik-Cab",
//   },

//   {
//     id: "09",
//     title: "Navi Mumbai Cab Service",
//     image: "/images/services/Navi-Mumbai-Cab-Service.jpg",
//     icon: <FaTaxi />,
//     description:
//       "Reliable Navi Mumbai cab service for local travel, airport transfers, and outstation journeys.",
//     feature1: "Local Taxi",
//     feature2: "24×7 Available",
//     link: "/Navi-Mumbai-Cab-Service",
//   },

// //   {
// //     id: "10",
// //     title: "Navi Mumbai International Airport Cab",
// //     image: "/images/services/Navi-Mumbai-International-Airport-Cab.jpg",
// //     icon: <FaPlaneDeparture />,
// //     description:
// //       "Premium airport cab service from Navi Mumbai International Airport to all destinations.",
// //     feature1: "Airport Transfer",
// //     feature2: "Premium Cars",
// //     link: "/Navi-Mumbai-International-Airport-Cab",
// //   },
// ];

// const Services = () => {
//   return (
   
   
   
//    <
// >
//  <section className="page-banner">
//       <div className="page-banner-container">
//         <h2>
//           OUR SERVICES
//         </h2>
//       </div>
//     </section>
//    <section className="stt-services-section">

//       <div className="container">

       
//         <div className="row">

//           {services.map((item) => (

//             <div
//               className="col-lg-4 col-md-6 mb-4"
//               key={item.id}
//             >

//               <div className="stt-card">

//                 {/* Image */}

//                 <div className="stt-card-image">

//                   <img
//                     src={item.image}
//                     alt={item.title}
//                   />

//                   <span className="stt-card-number">
//                     {item.id}
//                   </span>

//                 </div>

//                 {/* Content */}

//                 <div className="stt-card-content">

//                   {/* <div className="stt-card-icon">
//                     {item.icon}
//                   </div> */}

//                   <h3 className="clr">
//                     {item.title}
//                   </h3>

//                   <p>
//                     {item.description}
//                   </p>

//                   {/* Features */}

//                   <div className="stt-features">

//                     <span>
//                       {item.feature1}
//                     </span>

//                     <span>
//                       {item.feature2}
//                     </span>

//                   </div>

//                   {/* Footer */}

//                   <div className="stt-footer">

//                     <a
//                       href="/booking"
//                       className="stt-btn"
//                     >
//                       Book Now

//                       <FaArrowRight />

//                     </a>

//                   </div>

//                 </div>

//               </div>

//             </div>

//           ))}

//         </div>

//       </div>

//     </section>
// </>
//   );
// };

// export default Services;


import React from "react";
import "./Services.css";

import {
  FaPlaneDeparture,
  FaTaxi,
  FaRoute,
  FaMapMarkerAlt,
  FaCarSide,
  FaArrowRight,
  FaTags,
  FaRoad,
  FaShieldAlt,
  FaClock,
} from "react-icons/fa";

const services = [
  {
    id: "01",
    title: "Cab Service in Thane",
    image: "/images/services/Cab-Service-in-Thane.jpg",
    icon: <FaTaxi />,
    description:
      "Professional taxi services in Thane for local, airport, and outstation travel with experienced drivers.",
    feature1: "24×7 Service",
    feature2: "Safe Travel",
    link: "/Cab-Service-in-Thane",
  },
  {
    id: "02",
    title: "Cab Services in Mumbai",
    image: "/images/services/Cab-Services-in-Mumbai.jpg",
    icon: <FaCarSide />,
    description:
      "Affordable cab services in Mumbai for local rides, airport transfers, and outstation trips.",
    feature1: "Affordable Fare",
    feature2: "Professional Drivers",
    link: "/Cab-Services-in-Mumbai",
  },
  {
    id: "03",
    title: "Cheapest Cab Service in Mumbai",
    image: "/images/services/Cheapest-Cab-Service-in-Mumbai.jpg",
    icon: <FaTags />,
    description:
      "Book the cheapest cab service in Mumbai with clean cars and reliable drivers for every journey.",
    feature1: "Lowest Fare",
    feature2: "24×7 Booking",
    link: "/Cheapest-Cab-Service-in-Mumbai",
  },
  {
    id: "04",
    title: "Mumbai Airport Cab Service",
    image: "/images/services/Mumbai-Airport-Cab-Service.jpg",
    icon: <FaPlaneDeparture />,
    description:
      "Reliable Mumbai Airport pickup and drop taxi service with timely airport transfers.",
    feature1: "Airport Pickup",
    feature2: "Flight Tracking",
    link: "/Mumbai-Airport-Cab-Service",
  },
  {
    id: "05",
    title: "Mumbai Airport to Pune Cab",
    image: "/images/services/Mumbai-Airport-to-Pune-Cab.jpg",
    icon: <FaRoute />,
    description:
      "Comfortable Mumbai Airport to Pune cab service for one-way and round-trip travel.",
    feature1: "One Way",
    feature2: "Round Trip",
    link: "/Mumbai-Airport-to-Pune-Cab",
  },
  {
    id: "06",
    title: "Mumbai Airport to Surat Cab",
    image: "/images/services/Mumbai-Airport-to-Surat-Cab.jpg",
    icon: <FaRoad />,
    description:
      "Book airport taxi from Mumbai Airport to Surat with experienced outstation drivers.",
    feature1: "Outstation",
    feature2: "Comfort Ride",
    link: "/Mumbai-Airport-to-Surat-Cab",
  },
  {
    id: "07",
    title: "Mumbai Outstation Cabs",
    image: "/images/services/Mumbai-Outstation-Cabs.jpg",
    icon: <FaRoute />,
    description:
      "Comfortable outstation taxi service from Mumbai to destinations across Maharashtra and India.",
    feature1: "24×7 Service",
    feature2: "Professional Driver",
    link: "/Mumbai-Outstation-Cabs",
  },
  {
    id: "08",
    title: "Mumbai to Nashik Cab Service",
    image: "/images/services/Mumbai-to-Nashik-cab-service.jpg",
    icon: <FaMapMarkerAlt />,
    description:
      "Safe and affordable Mumbai to Nashik cab service for business, family, and pilgrimage trips.",
    feature1: "Door Pickup",
    feature2: "Safe Journey",
    link: "/Mumbai-to-Nashik-Cab",
  },
  {
    id: "09",
    title: "Navi Mumbai Cab Service",
    image: "/images/services/Navi-Mumbai-Cab-Service.jpg",
    icon: <FaTaxi />,
    description:
      "Reliable Navi Mumbai cab service for local travel, airport transfers, and outstation journeys.",
    feature1: "Local Taxi",
    feature2: "24×7 Available",
    link: "/Navi-Mumbai-Cab-Service",
  },
];

const Services = () => {
  return (
    <>
      {/* ================= PAGE BANNER ================= */}
     <section className="page-banner">
      <div className="page-banner-container">
        <h2>
          OUR SERVICES
        </h2>
      </div>
    </section>

      {/* ================= SERVICES SECTION ================= */}
      <section className="stt-services-section">
        <div className="stt-services-container">

          {/* Section Heading */}
          <div className="stt-section-heading">
            <span className="stt-section-label">
              WHAT WE OFFER
            </span>

            <h2>
              Reliable <span>Travel Services</span>
            </h2>

            <p>
              From local city rides to long-distance journeys, choose a
              comfortable and reliable travel service designed around you.
            </p>
          </div>

          {/* Services Grid */}
          <div className="stt-services-grid">
            {services.map((item) => (
              <article
                className="stt-service-card"
                key={item.id}
              >

                {/* Image */}
                <div className="stt-card-image">

                  <img
                    src={item.image}
                    alt={item.title}
                    loading="lazy"
                  />

                  <div className="stt-image-overlay"></div>

                  {/* Number */}
                  <span className="stt-card-number">
                    {item.id}
                  </span>

                  {/* Icon */}
                  <div className="stt-service-icon">
                    {item.icon}
                  </div>

                </div>

                {/* Content */}
                <div className="stt-card-content">

                  <h3>{item.title}</h3>

                  <p className="stt-card-description">
                    {item.description}
                  </p>

                  {/* Features */}
                  <div className="stt-features">

                    <div className="stt-feature">
                      <span className="stt-feature-icon">
                        <FaShieldAlt />
                      </span>

                      <span className="stt-feature-text">
                        {item.feature1}
                      </span>
                    </div>

                    <div className="stt-feature">
                      <span className="stt-feature-icon">
                        <FaClock />
                      </span>

                      <span className="stt-feature-text">
                        {item.feature2}
                      </span>
                    </div>

                  </div>

                  {/* Button */}
                  <div className="stt-card-footer">

                    <a
                      href={item.link}
                      className="stt-book-btn"
                    >
                      <span>Book Now</span>

                      <span className="stt-btn-arrow">
                        <FaArrowRight />
                      </span>
                    </a>

                  </div>

                </div>
              </article>
            ))}
          </div>

        </div>
      </section>
    </>
  );
};

export default Services;
